export const reverseDate = (date: string | null) => {
  if (!date) return null
  return date.split('T')[0].split('-').reverse().join('-')
}

export const GIFTS = [
  'Wine - Zisola',
  'Wine - Eagles Nest',
  'Wine - Miraval',
  'Guilty - Gourmet',
  'Guilty - Karaoke',
  'Guilty - Aroma diffuser',
  'Charity - Dierenbescherming',
  'Charity - The Ocean Cleanup',
  'Charity - Rode Kruis',
]

export const ORDER_STATUSES = [
  { value: 1, label: 'New' },
  { value: 2, label: 'Ordered for direct delivery' },
  { value: 3, label: 'Ordered for Magno delivery' },
  { value: 4, label: 'Forwarded to Recipient' },
  { value: 5, label: 'Pick up at Postal office' },
  { value: 6, label: 'Charity' },
  { value: 7, label: 'Completed' },
]

export const INVOICE_STATUSES = [
  'Invoice pending',
  'Invoice archived',
  'No invoice required',
]
